import { HttpErrorResponse } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

async function readBlobErrorMessage(error: unknown): Promise<string | null> {
  if (!(error instanceof HttpErrorResponse) || !(error.error instanceof Blob)) return null;
  try {
    const body: unknown = JSON.parse(await error.error.text());
    const message = (body as { message?: unknown } | null)?.message;
    return typeof message === 'string' && message.length > 0 ? message : null;
  } catch {
    return null;
  }
}

export async function resolveBlobFailureKey(
  error: unknown,
  fallbackKey: string,
  translate: TranslateService,
): Promise<string> {
  const message = await readBlobErrorMessage(error);
  return message !== null && translate.instant(message) !== message ? message : fallbackKey;
}
